import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { eChungChiChungNhanSinhVienActionIds, IChungChiChungNhanSinhVienActionTypes } from "../../action-types/chung-chi-chung-nhan/chungChiChungNhanSinhVienActions";
import { IChungChiChungNhanSinhVien } from "../../../model/response/chung-chi-chung-nhan/IChungChiChungNhanSinhVien";
import { chungChiChungNhanSinhVienApi } from "../../../api/chung-nhan-chung-chi/chungChiChungNhanSinhVienApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";


export function* ChungChiChungNhanSinhVienSaga(): any {
    yield takeLatest(eChungChiChungNhanSinhVienActionIds.LOAD_START, loadWorker);
    yield takeEvery(eChungChiChungNhanSinhVienActionIds.SAVE_START, saveWorker);
    yield takeEvery(eChungChiChungNhanSinhVienActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eChungChiChungNhanSinhVienActionIds.DELETES_START, deletesWorker);
    yield takeEvery(eChungChiChungNhanSinhVienActionIds.LOAD_BY_CHUNG_CHI_CHUNG_NHAN_START, loadByChungChiChungNhanWorker);
}


function* loadWorker(): any {
    const res: IBaseResponse = yield call(chungChiChungNhanSinhVienApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.LOAD_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* loadByChungChiChungNhanWorker(action: IChungChiChungNhanSinhVienActionTypes): any {
    const chungChiChungNhanId = action.payload as number;
    const res: IBaseResponse = yield call(chungChiChungNhanSinhVienApi.SelectByChungChiChungNhan, chungChiChungNhanId);
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.LOAD_BY_CHUNG_CHI_CHUNG_NHAN_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.LOAD_BY_CHUNG_CHI_CHUNG_NHAN_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* saveWorker(action: IChungChiChungNhanSinhVienActionTypes): any {
    let res: IBaseResponse;
    const data = action.payload as IChungChiChungNhanSinhVien;
    if (data.id > 0) {
        res = yield call(chungChiChungNhanSinhVienApi.Update, data.id, data);
    } else {
        res = yield call(chungChiChungNhanSinhVienApi.Insert, data);
    }
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.SAVE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.SAVE_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteWorker(action: IChungChiChungNhanSinhVienActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(chungChiChungNhanSinhVienApi.Delete, id);
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.DELETE_SUCCESS(undefined));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.DELETE_ERROR(res.message ?? "Có lỗi")
        );
    }
}


function* deletesWorker(action: IChungChiChungNhanSinhVienActionTypes): any {
    const ids = action.payload as IIdsRequest;
    const res: IBaseResponse = yield call(chungChiChungNhanSinhVienApi.Deletes, ids);
    if (res.is_success) {
        yield put(rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.DELETES_SUCCESS(undefined));
    } else {
        yield put(
            rootActions.chungChiChungNhan.chungChiChungNhanSinhVien.DELETES_ERROR(res.message ?? "Có lỗi")
        );
    }
}